export const ASSETS = {
  // Real brand assets provided by the client (whitespace-trimmed, served locally)
  shuruKarLogo: "/shurukar-logo.png",
  bharatProjectLogo: "/bharat-project-logo.png",
  launchPhoto:
    "https://customer-assets-jt897jd0.emergentagent.net/job_d15035d4-aae7-4ff6-97b1-85c99880badb/artifacts/izgizbo6_Bharat%20project%20launch.webp",
  founderPortrait:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_nidar-shuru/artifacts/srx6yiec_shradha.jpg",
};

export const SOCIALS = [
  { name: "X", url: "https://x.com/BharatProjectCo" },
  { name: "Instagram", url: "https://www.instagram.com/thebharatproject_" },
  { name: "YouTube", url: "https://www.youtube.com/c/thebharatproject" },
  { name: "LinkedIn", url: "https://www.linkedin.com/company/thebharatproject" },
];

export const NAV_LINKS = [
  { href: "#why", label: "Why ShuruKar" },
  { href: "#features", label: "What You Get" },
  { href: "#movement", label: "The Movement" },
  { href: "#submit", label: "Submit Idea" },
];

export const CITIES = [
  "Jaipur", "Lucknow", "Kanpur", "Bhilai", "Muzaffarpur",
  "Indore", "Coimbatore", "Kashmir", "Guwahati", "+ aur bahut se",
];

export const IDEA_CHIPS = [
  "Makhana", "Tiffin Service", "Boutique", "Coaching Centre",
  "Kirana", "Dairy", "Handmade Products", "AI Startup",
];
